module.exports = __webpack_public_path__ + "static/media/242 Park - Concept Drawing 2.e72b7568.jpg";